import {
  InfiniteList,
  InfiniteListProps,
  ShortsGrid,
  VideosList,
} from "@components/core/infinite-list";
import NewNewsCard from "@components/core/new-news-card";
import {
  NewsSummaryFragment,
  VideoSummaryFragment,
} from "@graphql/generated/graphql";

interface IPublisherNewsListProps {
  infiniteListProps: InfiniteListProps;
  news: NewsSummaryFragment[];
}

export const PublisherNewsList: React.FC<IPublisherNewsListProps> = ({
  infiniteListProps,
  news,
}) => {
  return (
    <InfiniteList {...infiniteListProps}>
      <div className="flex flex-col items-stretch divide-y divide-light-background">
        {news.map((news) => (
          <div className="py-4" key={news.id}>
            <NewNewsCard news={news} showPublisher={false} big />
          </div>
        ))}
      </div>
    </InfiniteList>
  );
};

interface IPublisherVideosListProps {
  infiniteListProps: InfiniteListProps;
  videos: VideoSummaryFragment[];
}

export const PublisherVideosList: React.FC<IPublisherVideosListProps> = ({
  infiniteListProps,
  videos,
}) => {
  return (
    <InfiniteList {...infiniteListProps}>
      <VideosList videos={videos} showPublisher={false} />
    </InfiniteList>
  );
};

interface IPublisherShortsGridProps {
  infiniteListProps: InfiniteListProps;
  shorts: VideoSummaryFragment[];
}

export const PublisherShortsGrid: React.FC<IPublisherShortsGridProps> = ({
  infiniteListProps,
  shorts,
}) => {
  return (
    <InfiniteList {...infiniteListProps}>
      <ShortsGrid shorts={shorts} />
    </InfiniteList>
  );
};
